import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, EntityModel, ReportModel, ResponseDeleteModel, GeneratedReportModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IReportsService {
    generateReport(id): ng.IPromise<GeneratedReportModel>
}

export class ReportsService implements IReportsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    generateReport(id, state: any = {}) {
        var generateReport: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.reports['generateReport']
        state.request = generateReport({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
}
